import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Input, Checkbox } from '@gamesb42/ui-kit';
// @ts-ignore
import * as Validator from 'validatorjs';

import { appInfoInst } from '.';

import s from './styles.module.scss';

// Переиспользуемый компонент для платформы
const PlatformField = observer(
  ({
    platform,
    label,
    linkLabel,
    checked,
    value,
    onToggle,
    onChange,
    error,
  }: {
    platform: string;
    label: string;
    linkLabel: string;
    checked: boolean;
    value: string;
    onToggle: (checked: boolean) => void;
    onChange: (value: string) => void;
    error?: string;
  }) => (
    <div>
      <Checkbox checked={checked} onChange={(e) => onToggle(e.target.checked)}>
        {label}
      </Checkbox>

      {checked && (
        <div style={{ marginTop: '32px' }}>
          <Input
            size="large"
            label={linkLabel}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            status={error ? 'error' : undefined}
          />
          {error && <div className={s.errorMessage}>{error}</div>}
        </div>
      )}
    </div>
  ),
);

const Step1 = observer(() => {
  const rules = {
    distribution: {
      appleStoreComment: 'url|regex:/apple/',
      googleStoreComment: 'url|regex:/google/',
      steamComment: 'url|regex:/steam/',
    },
  };

  useEffect(() => {
    const validation = new Validator(appInfoInst.values, rules, {
      url: 'The link format is invalid',
      regex: 'Link is not correct',
    });

    const isValid = validation.passes();

    appInfoInst.isStepIsValid[1] =
      [
        appInfoInst.values.distribution.appleStoreComment,
        appInfoInst.values.distribution.googleStoreComment,
        appInfoInst.values.distribution.steamComment,
        appInfoInst.values.distribution.otherComment,
      ].some((el) => el?.length > 0) && isValid;
  }, [
    appInfoInst.values.distribution.appleStoreComment,
    appInfoInst.values.distribution.googleStoreComment,
    appInfoInst.values.distribution.steamComment,
    appInfoInst.values.distribution.otherComment,
  ]);

  // Для отображения ошибок создаем валидацию отдельно
  const validation = new Validator(appInfoInst.values, rules, {
    url: 'The link format is invalid',
    regex: 'Link is not correct',
  });

  return (
    <>
      <h3>
        <b>Where is your app or game distributed now?*</b>
      </h3>
      <div
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
        }}
      >
        <PlatformField
          platform="apple"
          label="Apple App Store"
          linkLabel="Link to your game/app at Apple App Store*"
          checked={appInfoInst.values.distribution.appleStore}
          value={appInfoInst.values.distribution.appleStoreComment}
          onToggle={(checked) => {
            appInfoInst.values.distribution.appleStore = checked;
          }}
          onChange={(value) => {
            appInfoInst.values.distribution.appleStoreComment = value;
          }}
          error={validation.errors.first('distribution.appleStoreComment')}
        />

        <PlatformField
          platform="google"
          label="Google Play"
          linkLabel="Link to your game/app at Google Play*"
          checked={appInfoInst.values.distribution.googleStore}
          value={appInfoInst.values.distribution.googleStoreComment}
          onToggle={(checked) => {
            appInfoInst.values.distribution.googleStore = checked;
          }}
          onChange={(value) => {
            appInfoInst.values.distribution.googleStoreComment = value;
          }}
          error={validation.errors.first('distribution.googleStoreComment')}
        />

        <PlatformField
          platform="steam"
          label="Steam"
          linkLabel="Link to your game/app at Steam*"
          checked={appInfoInst.values.distribution.steam}
          value={appInfoInst.values.distribution.steamComment}
          onToggle={(checked) => {
            appInfoInst.values.distribution.steam = checked;
          }}
          onChange={(value) => {
            appInfoInst.values.distribution.steamComment = value;
          }}
          error={validation.errors.first('distribution.steamComment')}
        />

        <PlatformField
          platform="other"
          label="Other"
          linkLabel="Enter your distribution platform"
          checked={appInfoInst.values.distribution.other}
          value={appInfoInst.values.distribution.otherComment}
          onToggle={(checked) => {
            appInfoInst.values.distribution.other = checked;
          }}
          onChange={(value) => {
            appInfoInst.values.distribution.otherComment = value;
          }}
        />
      </div>
    </>
  );
});

export default Step1;
